import styled from 'styled-components';
import { em } from 'polished';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyledSearchResults = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

  position: absolute;
  top: ${em(41)};
  left: 0;
  width: 100%;

  background-color: ${colors.background};
  border: 1px solid ${colors.hairline};
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1);
  padding: ${em(24)} ${em(48)} ${em(8)} ${em(48)};

  ${media.tabletSmall`
    padding: ${em(12)} ${em(24)} ${em(10)} ${em(24)};
  `}

  & > ul {
    list-style: none;
    margin: 0;
    padding-left: 0;

    & > li {
      p {
        color: ${colors.primary};
        margin-bottom: 0
      }

      small {
        color: ${colors.lightText};
      }

      a {
        cursor: pointer;
        display: inline-block;
        text-decoration: none;

        &:hover > p {
          color: ${colors.primaryLight};
        }
      }

      &:first-child p {
        margin-top: 0.5em;
      }
    }
  }

  & > p {
    margin-top: 0;
    margin-bottom: 1em;
  }
`;

export const StyledFooter = styled.div`
  margin-top: 1em;
  text-align: right;

  & > button {
    padding: 0.5em;
    transform: translateX(0.5em);
  }
`;



// WEBPACK FOOTER //
// ./src/modules/Header/components/Search/components/SearchResults/styled.js